import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import Tick from "../Tick";

type BillingTableProps = {};

const BillingTable: React.FC<BillingTableProps> = ({ ...props }) => {
  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>Pay as you go (monthly). Credit cards and SEPA payments.</BoldCell>
          <td><Tick/></td>
        </tr>
        <tr>
          <BoldCell>Volume plans, prepayment, and custom invoices (&gt;$1,000/month)</BoldCell>
          <td><Tick/></td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default BillingTable;
